











import { Prop, Component, Vue } from 'vue-property-decorator';
import { IMatrix, getMatrixStr } from '@/misc';

@Component({
  components: {
  },
})
export default class SvgTarget extends Vue {
  @Prop() protected matrix!: IMatrix;

  protected get sMatrix() {
    return getMatrixStr(this.matrix);
  }
}
